import React, { Component } from 'react';
import styled from 'styled-components';
import { Input, PieChart } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { connect } from 'react-redux';
import { modalActions, addAccountActions, accountActions } from '../../../redux/root-action';
import { isNumeric } from '../../../utils/helpers';

const StyledInvestmentMixContainer = styled.div`
  display: flex;
  padding-top: 24px;
`;

const StyledInputFieldsContainer = styled.div`
  margin-left: 56px;
  @media only screen and (max-width: 767px) {
    margin-left: 0px;
  }
`;

const StyledInputContainer = styled.div`
  display: flex;
  width: 200px;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 767px) {
    width: 177px;
  }
`;

const StyledEllipse = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.color};
  margin: 6px 8px 8px 8px;
`;

const StyledLabel = styled.div`
  display: flex;
`;

const StyledFieldContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  @media only screen and (max-width: 767px) {
    margin-top: 16px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
`;

const StyledInputLabel = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  .error {
    width: 256px;
    color: ${tokens.ColorFunctionalRed700};
    font-size: 14px;
  }
  @media only screen and (max-width: 767px) {
    height: auto;
  }
`;

class AddAccountInvestmentMix extends Component<any, any> {
  handlePercentChange = (event: any) => {
    const {
      account: {
        selectedAccount: { assetAllocation },
      },
      updateSelectedAccount,
    } = this.props;
    if (!isNumeric(Number(event.target.value))) {
      return;
    }
    if (!assetAllocation) {
      updateSelectedAccount({
        assetAllocation: {
          stockPercent: 0,
          bondsPercent: 0,
          moneyMarketPercent: 0,
          otherPercent: 0,
          [event.target.name]: Number(event.target.value),
        },
      });
    } else {
      updateSelectedAccount({
        assetAllocation: { ...assetAllocation, [event.target.name]: Number(event.target.value) },
      });
    }
  };

  getPieChartData = () => {
    const {
      account: {
        selectedAccount: { assetAllocation },
      },
    } = this.props;
    if (!assetAllocation) {
      return [0, 0, 0, 0, 100];
    }
    const { stockPercent, bondsPercent, moneyMarketPercent, otherPercent } = assetAllocation;
    const total = stockPercent + bondsPercent + moneyMarketPercent + otherPercent;
    if (total > 100) {
      return [0, 0, 0, 0, 100];
    }
    const remaining = 100 - total;
    return [stockPercent, bondsPercent, moneyMarketPercent, otherPercent, remaining];
  };

  render(): JSX.Element {
    const {
      account: {
        selectedAccount: {
          assetAllocation = {},
          error = {},
          isOverriddenYodleeAccount,
          hasYodleeAssetAllocationError,
          isYodleeAccount,
        },
      },
    } = this.props;

    const investmentMixFields = [
      {
        name: 'stockPercent',
        value: assetAllocation && assetAllocation['stockPercent'] ? assetAllocation['stockPercent'] : 0,
        displayName: 'Stocks',
        color: tokens.ColorBrandInteractiveBlue,
        placeholder: 0,
      },
      {
        name: 'bondsPercent',
        value: assetAllocation && assetAllocation['bondsPercent'] ? assetAllocation['bondsPercent'] : 0,
        displayName: 'Bonds',
        color: tokens.ColorChartingBlue500,
        placeholder: 0,
      },
      {
        name: 'moneyMarketPercent',
        value: assetAllocation && assetAllocation['moneyMarketPercent'] ? assetAllocation['moneyMarketPercent'] : 0,
        displayName: 'Short-Term',
        color: tokens.ColorChartingTeal100,
        placeholder: 0,
      },
      {
        name: 'otherPercent',
        value: assetAllocation && assetAllocation['otherPercent'] ? assetAllocation['otherPercent'] : 0,
        displayName: 'Other',
        color: tokens.ColorChartingPurple500,
        placeholder: 0,
      },
    ];

    return (
      <React.Fragment>
        <StyledFieldContainer>
          <StyledInputLabel>Investment Mix</StyledInputLabel>
          {error.assetAllocation && hasYodleeAssetAllocationError && (
            <StyledInputLabel>
              <span className="error">Please provide the correct investment mix.</span>
            </StyledInputLabel>
          )}
        </StyledFieldContainer>
        <StyledInvestmentMixContainer>
          <PieChart
            text={error.assetAllocation}
            data={this.getPieChartData()}
            hasError={!!error.assetAllocation}
          ></PieChart>
          <StyledInputFieldsContainer>
            {investmentMixFields.map(({ name, color, value, displayName, placeholder }) => (
              <StyledInputContainer key={name}>
                <StyledLabel>
                  <StyledEllipse color={color} /> <div>{displayName}</div>{' '}
                </StyledLabel>
                {isYodleeAccount && !isOverriddenYodleeAccount && !hasYodleeAssetAllocationError ? (
                  <StyledInputLabel>{value}%</StyledInputLabel>
                ) : (
                  <Input
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    hasError={!!error.assetAllocation}
                    trailingCharacter="%"
                    width={80}
                    textAlign="right"
                    onChange={this.handlePercentChange}
                    //onFocus={this.handleFocus}
                    //onBlur={this.handleBlur}
                    autoComplete="off"
                    aria-label={name}
                  />
                )}
              </StyledInputContainer>
            ))}
          </StyledInputFieldsContainer>
        </StyledInvestmentMixContainer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  accountFields: state.addAccount,
  account: state.account,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  updateField: addAccountActions.updateField,
  updateSelectedAccount: accountActions.updateSelectedAccount,
})(AddAccountInvestmentMix);
